<template>
  <v-card class="modern-stats-card" elevation="0">
    <div class="modern-stats-header">
      <div class="modern-stats-title-row">
        <div class="modern-stats-title-icon">
          <v-icon color="white" size="18">mdi-chart-bar</v-icon>
        </div>
        <span class="modern-stats-title">{{ $t('pages.statistics') }}</span>
      </div>
    </div>
    <v-card-text class="pt-3 pb-3 px-3">
      <v-row no-gutters>
        <v-col
          v-for="data in allCounts"
          :key="data.title"
          cols="6"
          sm="6"
          md="3"
          class="stat-col"
          @click="handleOnClick(resolveStatisticsIconVariation(data.title).link)"
        >
          <div
            class="stat-item"
            :style="{ background: resolveStatisticsIconVariation(data.title).bgColor }"
          >
            <div
              class="stat-icon-wrap"
              :style="{ background: resolveStatisticsIconVariation(data.title).iconBg }"
            >
              <v-icon :color="resolveStatisticsIconVariation(data.title).iconColor" size="24">
                {{ resolveStatisticsIconVariation(data.title).icon }}
              </v-icon>
            </div>
            <div class="stat-text">
              <p class="stat-label">{{ $t('pages.' + data.title.toLowerCase()) }}</p>
              <h3 class="stat-value" :style="{ color: resolveStatisticsIconVariation(data.title).iconColor }">{{ data.total }}</h3>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    allCounts: { type: Array, default: () => [] },
  },
  methods: {
    resolveStatisticsIconVariation(title) {
      switch (title) {
        case 'Guardians': return { icon: 'mdi-account-group-outline', bgColor: 'rgba(123,31,162,0.08)', iconBg: 'rgba(123,31,162,0.15)', iconColor: '#7B1FA2', link: 'guardians' };
        case 'Schools':   return { icon: 'mdi-school', bgColor: 'rgba(25,118,210,0.08)', iconBg: 'rgba(25,118,210,0.15)', iconColor: '#1976D2', link: 'schools' };
        case 'Drivers':   return { icon: 'mdi-account-tie-hat-outline', bgColor: 'rgba(56,142,60,0.08)', iconBg: 'rgba(56,142,60,0.15)', iconColor: '#388E3C', link: 'drivers' };
        case 'Students':  return { icon: 'mdi-badge-account-outline', bgColor: 'rgba(245,124,0,0.08)', iconBg: 'rgba(245,124,0,0.15)', iconColor: '#F57C00', link: 'students' };
        case 'Directors': return { icon: 'mdi-account-star-outline', bgColor: 'rgba(230,81,0,0.08)', iconBg: 'rgba(230,81,0,0.15)', iconColor: '#e65100', link: null };
        case 'Buses':     return { icon: 'mdi-bus', bgColor: 'rgba(230,81,0,0.08)', iconBg: 'rgba(230,81,0,0.15)', iconColor: '#e65100', link: 'buses' };
        case 'Classes':   return { icon: 'mdi-google-classroom', bgColor: 'rgba(56,142,60,0.08)', iconBg: 'rgba(56,142,60,0.15)', iconColor: '#388E3C', link: 'classes' };
        default:          return { icon: 'mdi-account', bgColor: 'rgba(245,124,0,0.08)', iconBg: 'rgba(245,124,0,0.15)', iconColor: '#F57C00', link: null };
      }
    },
    handleOnClick(route) {
      if (route) this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.modern-stats-card { border-radius: 14px !important; border: 1px solid rgba(0,0,0,0.06) !important; overflow: hidden; }
.modern-stats-header { background: linear-gradient(90deg, #e65100, #f57c00); padding: 14px 20px; }
.modern-stats-title-row { display: flex; align-items: center; gap: 10px; }
.modern-stats-title-icon { width: 28px; height: 28px; background: rgba(255,255,255,0.2); border-radius: 8px; display: flex; align-items: center; justify-content: center; }
.modern-stats-title { color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.3px; }
.stat-col { padding: 6px !important; cursor: pointer; }
.stat-item { display: flex; align-items: center; gap: 10px; width: 100%; padding: 12px; border-radius: 12px; transition: transform 0.15s, box-shadow 0.15s; cursor: pointer; min-height: 72px; }
.stat-item:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.10); }
.stat-icon-wrap { width: 44px; height: 44px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.stat-text { flex: 1; min-width: 0; }
.stat-label { font-size: 10px; color: #94a3b8; margin-bottom: 2px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.stat-value { font-size: 22px; font-weight: 800; line-height: 1; }
@media (max-width: 600px) {
  .stat-item { padding: 10px; gap: 8px; }
  .stat-icon-wrap { width: 36px; height: 36px; }
  .stat-value { font-size: 18px; }
  .stat-label { font-size: 9px; }
}
</style>
